import { http } from '@/core/helpers/http.helper';
import i18n from '@/i18n';
import { LocationQuery } from 'vue-router';

export class UserInfoService {
   async getUserInfo(query?: LocationQuery) {
      const response = await http.get(`/user-info`, { params: { ...query } });
      return {
         ...response.data,
         modules: response.data.modules.map((m: any) => ({ ...m, description: m.description?.[i18n.global.locale.value] })),
      };
   }
}
